module.exports = __webpack_public_path__ + "static/img/third7.2496e229.png";